import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Bar, HorizontalBar, Line } from 'react-chartjs-2';
import moment from 'moment';
import async from 'async';

import Config from '../../config';
import Lang from '../../languages';

import Statistics from './Statistics';
import DataTable from './SurveryGraph';


class Dashboard extends Component {
 constructor(props) {
  super(props);

  this.state = {
   totals: [],
   last: []
  };
 }

 componentDidMount() {
  var jobs = {};
  var self = this;

  jobs.totals = (function (callback) {
   self.props.reqAPI(Config.apiURI + '/api/tickets/stats', 'POST', {
    groupBy: 'months',
    startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD')
   }).then(result => {
    callback(false, result);
   });
  })

  jobs.last = (function (callback) {
   self.props.reqAPI(Config.apiURI + '/api/tickets/stats', 'POST', {
    groupBy: 'days',
    startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD')
   }).then(result => {
    callback(false, result);
   });
  })

  async.parallel(jobs, function (err, results) {
   self.setState(results);
  });
 }

 capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
 }


 render() {
  moment.locale(Lang[this.props.session.language].locale);

  let totalsLabels = [];
  let totalsDataset = { sales: [], bookings: [], cancellations: [] };

  this.state.totals.map(data => {
   totalsLabels.push(this.capitalizeFirstLetter(data.label));
   totalsDataset.sales.push(data.sales);
   totalsDataset.bookings.push(data.bookings);
   totalsDataset.cancellations.push(-data.cancellations);
  });

  let lastLabels = [];
  let lastDataset = { sales: [], bookings: [], cancellations: [] };

  this.state.last.map(data => {
   lastLabels.push(this.capitalizeFirstLetter(data.label));
   lastDataset.sales.push(data.sales);
   lastDataset.bookings.push(data.bookings);
   lastDataset.cancellations.push(data.cancellations);
  });


  return (
   <Row>
    <DataTable/>
   </Row>
  )
 }

}

export default Dashboard;




// WEBPACK FOOTER //
// ./websources/views/Dashboard/index.js